module.exports = __webpack_public_path__ + "static/media/valvula-corte-02.8c1e099f.png";